export default __webpack_public_path__ + "static/media/e2.e1a6a0f0.png";